module.exports = __webpack_public_path__ + "static/featuredLg-68f0b693382bd5f885ba8d3e5292c6f2.svg";